<!-- role="group", not "img": this chart contains focusable controls, and
     role="img" removes them from the accessibility tree. The full data lives
     in the visually-hidden table below, so no <title>/<desc> is needed. -->
<svg class="chart-svg" [attr.viewBox]="'0 0 ' + viewW + ' ' + viewH" role="group"
     [attr.aria-label]="ariaLabel">

  <line class="baseline" x1="0" [attr.y1]="layout.baselineY"
        [attr.x2]="viewW" [attr.y2]="layout.baselineY"/>

  <ng-container *ngIf="layout.averageY !== null">
    <line class="average" x1="0" [attr.y1]="layout.averageY"
          [attr.x2]="viewW" [attr.y2]="layout.averageY"/>
    <!-- Legend in the reserved band, not on the line: see BAR_TOP_Y. The
         dashed swatch is what ties this figure to the line below it. -->
    <ng-container *ngIf="averageLabel">
      <line class="average" [attr.x1]="swatchX1" [attr.y1]="bandY - 2.5"
            [attr.x2]="swatchX2" [attr.y2]="bandY - 2.5"/>
      <text class="average-label" [attr.x]="averageTextX" [attr.y]="bandY">
        {{ averageLabel }}
      </text>
    </ng-container>
  </ng-container>

  <g *ngFor="let bar of layout.bars; trackBy: trackBar">
    <rect class="chart-hit bar"
          [class.current]="highlightIndex === bar.index"
          [attr.x]="bar.x" [attr.y]="bar.y"
          [attr.width]="bar.w" [attr.height]="bar.h"
          rx="3"
          tabindex="0"
          role="button"
          [attr.aria-pressed]="highlightIndex === bar.index"
          [attr.aria-label]="bar.label + ' ' + (displayValues[bar.index] ?? bar.label)"
          (click)="onSelect(bar)"
          (keydown.enter)="onSelect(bar, $event)"
          (keydown.space)="onSelect(bar, $event)"/>
    <text class="tick"
          [class.current]="highlightIndex === bar.index"
          [attr.x]="bar.x + bar.w / 2" [attr.y]="labelY"
          text-anchor="middle"
          aria-hidden="true">{{ bar.label }}</text>
  </g>
</svg>

<table class="chart-data">
  <caption>{{ ariaLabel }}</caption>
  <tbody>
    <tr *ngFor="let bar of layout.bars; trackBy: trackBar">
      <th scope="row">{{ bar.label }}</th>
      <td>{{ displayValues[bar.index] ?? data[bar.index]?.value }}</td>
    </tr>
  </tbody>
</table>
